import { findCar } from '@racedash/shared'
import { Datum, NoValue, Tile } from '../Tile'
import type { WidgetProps } from './props'

export default function CarNumber({ car, data }: WidgetProps<'carNumber'>) {
  const standing = findCar(data.standings, car)

  return <Tile label="Car">{car ? <Datum value={car} sub={standing?.class} /> : <NoValue />}</Tile>
}
